import { render } from "./WordList.vue?vue&type=template&id=44d9910e&scoped=true"
import script from "./WordList.vue?vue&type=script&lang=js"
export * from "./WordList.vue?vue&type=script&lang=js"

import "./WordList.vue?vue&type=style&index=0&id=44d9910e&scoped=true&lang=css"

import exportComponent from "/home/rich/web/spelling-bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d9910e"]])

export default __exports__